import { useEffect, useState } from 'react';
import { adminService, type DashboardStats } from '../../services/admin.service';
import './AdminDashboard.css';

export default function AdminDashboard() {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    adminService
      .getDashboard()
      .then((res) => {
        if (res.success && res.data) setStats(res.data);
        else setError(res.message || 'Ошибка загрузки');
      })
      .catch(() => setError('Ошибка загрузки данных'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="admin-dashboard">
        <h1>Дашборд</h1>
        <p className="admin-dashboard-loading">Загрузка...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-dashboard">
        <h1>Дашборд</h1>
        <p className="admin-dashboard-error">{error}</p>
      </div>
    );
  }

  const cards = [
    { title: 'Пользователи', value: stats?.usersCount ?? 0, key: 'users' },
    { title: 'Животные', value: stats?.animalsCount ?? 0, key: 'animals' },
    { title: 'Фермы', value: stats?.farmsCount ?? 0, key: 'farms' },
    { title: 'Регионы', value: stats?.regionsCount ?? 0, key: 'regions' },
  ];

  return (
    <div className="admin-dashboard">
      <h1>Дашборд</h1>
      <p className="admin-dashboard-desc">Общая статистика системы</p>
      <div className="admin-dashboard-cards">
        {cards.map(({ title, value, key }) => (
          <div key={key} className="admin-dashboard-card">
            <div className="admin-dashboard-card-title">{title}</div>
            <div className="admin-dashboard-card-value">{value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
